module.exports = __webpack_public_path__ + "img/826.3fbe7f9b.png";